export default __webpack_public_path__ + "static/media/work-data-file@2x.c561a8eb.svg";